export const STRIPE_3DS_COMPLETE_MESSAGE_NAME =
  'stripe-3ds-authentication-complete';
